/**
 * Site-wide configuration constants.
 *
 * These values are safe to expose to the browser (none are secrets):
 *  - GA measurement IDs and domains are already visible in page source.
 *  - The Web3Forms access key stays server-side in the Netlify function.
 */

/** Canonical production origin, used for canonical/sitemap/OG URLs. */
export const SITE_URL = "https://shreemateltourism.in";

/** Human-readable brand name. */
export const SITE_NAME = "Shree Matel Tourism";

/**
 * GA4 Measurement ID. Overridable per-environment via
 * REACT_APP_GA_MEASUREMENT_ID so previews can use a different property (or
 * none). Analytics is disabled automatically when this is empty.
 */
export const GA_MEASUREMENT_ID =
  process.env.REACT_APP_GA_MEASUREMENT_ID || "G-TMX8XXCG6J";

/** WhatsApp contact number in international format, digits only (for wa.me). */
export const WHATSAPP_NUMBER = "918866077880";

/** Default prefilled message for the WhatsApp click-to-chat button. */
export const WHATSAPP_MESSAGE =
  "Hi Shree Matel Tourism, I'd like to know more about your tour packages.";

/**
 * Whether to show package prices on the site. When false, package cards
 * and the booking modal show a "Pricing coming soon" badge in place of
 * the amount instead of an empty gap — the price data stays in place, so
 * flipping this back to true brings it back with no other changes needed.
 */
export const SHOW_PACKAGE_PRICES = false;

/** Office address, shown on the Contact page and in the footer. */
export const OFFICE_ADDRESS =
  "Shop No. 3rd FF, Aggarwal Center, opp. Oswal Resturant, Income Tax, Ahmedabad, Gujarat 380014";

/**
 * Google Maps link to our verified business listing, addressed by its
 * Maps CID (Customer ID) rather than a text search — so it always opens
 * the correct pin even if the address text or name changes later.
 * (CID = hex place id `727a504897d82396` from the listing's share link,
 * converted to decimal.) Plain link, no API key, no script loaded.
 */
export const OFFICE_MAP_URL = "https://www.google.com/maps?cid=8248993940197876630";
